import React, {Component} from "react";
import App from "../App";
import AddButton from "../common/AddButton/AddButton";
import Loading from "../common/Loading/Loading";
import AccountTable from "./components/AccountTable";
import AccountsPagination from "./components/AccountsPagination";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button, Input, InputGroup, InputGroupAddon} from "reactstrap";
import "./Accounts.css";
import AccountService from "../services/account-service";
import ToastOptions from "../common/toast/toastr-config.js";
import CreateDialog from "../common/CreateDialog/CreateDialog";
import history from "../history";
import toastr from "toastr";
import lodash from "lodash";
import FilterDropDown from "../common/Filter/FilterDropDown";
import AuthorizationService from "../services/authorization-service";
import Permissions from "../authentication/Permissions"

export default class Accounts extends Component {
  mount = false;

  constructor(props) {
    super(props);
    this.state = {
      appSchemas: {},
      page: 0,
      per_page: 25,
      accounts: [],
      loading: false,
      search_query: "",
      search_status: "all",
      search_internal: "all",
      sorting_field: "",
      sorting_order: 1,
      isAddAccountModalVisible: false,
      newAccountName: "",
      newAccountCustomerId: "",
      newInternalFlag: false,
      invalidFields: {
        name: {
          invalid: false,
          message: ""
        },
        customerId: {
          invalid: false,
          message: ""
        }
      },
      isDialogLoading: false,
      queryParams: "",
      isInFocus: false
    };

    this.debounceSearch = lodash.debounce(this.queryAccounts, 100);
    this.debouncePagination = lodash.debounce(this.changePage, 100);
  }

  componentWillMount() {
    if (this.props.location.search !== "") {
      let searchQuery = this.props.location.search;
      const searchParams = searchQuery
        .replace("?", "")
        .split("&")
        .reduce(function(prev, curr, i, arr) {
          const parameter = curr.split("=");
          prev[decodeURIComponent(parameter[0])] = decodeURIComponent(
            parameter[1]
          );
          return prev;
        }, {});

      this.setState({
        search_status: searchParams.status === "null" ? "all" : searchParams.status
      });
    }
  }

  /**
   * In order to handle the situation where the user clicks on the Accounts link in the navigation pane, we want to reset the accounts list
   * I identified that when this link is clicked, the props.history.action is "PUSH", allowing me to identify a state when to reset the state.
   */
  componentWillReceiveProps(props) {
    if (props.history.action === "PUSH") {
      this.setState({
        search_query: "",
        search_status: "all",
        search_internal: "all",
        sorting_field: "",
        sorting_order: 1
      }, this.fetchAccounts)
    }
  }


  componentDidMount() {
    console.log("componentDidMount")
    this.mount = true;
    if (this.props.location.search !== "") {
      //const searchParams
      let searchQuery = this.props.location.search;
      const searchParams = searchQuery
          .replace("?", "")
          .split("&")
        .reduce(function(prev, curr, i, arr) {
          const parameter = curr.split("=");
          prev[decodeURIComponent(parameter[0])] = decodeURIComponent(
            parameter[1]
          );
          return prev;
        }, {});

      this.setState(
          {
            per_page: parseInt(searchParams.per_page, 10),
            page: parseInt(searchParams.page, 10),
            search_query: searchParams.keyword,
            search_status: searchParams.status === "null" ? "all" : searchParams.status,
            search_internal: searchParams.internal === "null" ? "all" : searchParams.internal
          },
        () => this.fetchAccounts()
      );
    } else {
      history.replace("/accounts");
      this.fetchAccounts();
    }
  }

  componentWillUnmount() {
    this.mount = false;
    this.debounceSearch.cancel();
    this.debouncePagination.cancel();
  }

  handleAddAccountDialogToggle = async () => {
    if (!this.state.isAddAccountModalVisible) {
      this.setState({
        isAddAccountModalVisible: !this.state.isAddAccountModalVisible
      });
    } else if (this.state.isAddAccountModalVisible) {
      this.resetState();
    }
  };

  resetState = () => {
    this.setState({
      isAddAccountModalVisible: false,
      newAccountName: "",
      newAccountCustomerId: "",
      newInternalFlag: false,
      invalidFields: {
        name: {
          invalid: false,
          message: ""
        },
        customerId: {
          invalid: false,
          message: ""
        }
      }
    });
  };

  validateName = e => {
    let newName = e.target.value.trim();
    let isNameInvalid = this.state.invalidFields.name.invalid;
    let message = this.state.invalidFields.name.message;
    if (newName === "") {
      isNameInvalid = true;
      message = "Required field";
    } else if (!/^([0-9a-zA-Z \\$.%_-]*)$/.test(newName)) {
      isNameInvalid = true;
      message =
        "Name must contains only letters, numbers and special characters: ._\\-$ %";
    } else {
      isNameInvalid = false;
      message = "";
    }

    this.setState({
      invalidFields: {
        ...this.state.invalidFields,
        name: {
          invalid: isNameInvalid,
          message: message
        }
      },
      newAccountName: e.target.value
    });
  };

  setInternalFlag = e => {
    this.setState({
      newInternalFlag: e.target.checked
    })

  }

  validateCustomerId = e => {
    let newCustomerId = e.target.value;
    let isCustomerInvalid = this.state.invalidFields.customerId.invalid;
    let message = this.state.invalidFields.customerId.message;
    if (!/^([A-Za-z0-9]{0,64})$/.test(newCustomerId)) {
      isCustomerInvalid = true;
      message = "Must not contain space or special symbols.";
    } else {
      isCustomerInvalid = false;
      message = "";
    }

    this.setState({
      invalidFields: {
        ...this.state.invalidFields,
        customerId: {
          invalid: isCustomerInvalid,
          message: message
        }
      },
      newAccountCustomerId: e.target.value
    });
  };

  validateSave = (newAccountName, newAccountCustomerId) => {
    let newName = newAccountName.trim();
    let isNameInvalid = this.state.invalidFields.name.invalid;
    let messageName = this.state.invalidFields.name.message;
    if (newName === "") {
      isNameInvalid = true;
      messageName = "Required field";
    } else {
      isNameInvalid = false;
      messageName = "";
    }

    let newCustomerId = newAccountCustomerId;
    let isCustomerInvalid = this.state.invalidFields.customerId.invalid;
    let messageCustomer = this.state.invalidFields.customerId.message;
    if (!/^([A-Za-z0-9]{0,64})$/.test(newCustomerId)) {
      isCustomerInvalid = true;
      messageCustomer = "Must not contain space or special symbols.";
    } else {
      isCustomerInvalid = false;
      messageCustomer = "";
    }

    this.setState({
      invalidFields: {
        ...this.state.invalidFields,
        name: {
          invalid: isNameInvalid,
          message: messageName
        },
        customerId: {
          invalid: isCustomerInvalid,
          message: messageCustomer
        }
      },
      newAccountCustomerId: newAccountCustomerId,
      newAccountName: newAccountName
    });
  };

  addAccount = async () => {
    if (
      this.state.newAccountName.trim() !== "" &&
      /^([A-Za-z0-9]{0,64})$/.test(this.state.newAccountCustomerId)
    ) {
      try {
        this.setState({ isDialogLoading: true });
        const newAccount = {
          name: this.state.newAccountName.trim(),
          customerId: this.state.newAccountCustomerId,
          isInternal: this.state.newInternalFlag
        };
        const response = await AccountService.createAccount(newAccount);
        this.setState({ isDialogLoading: false });
        toastr.options = ToastOptions;
        toastr.success("The account has been created.");
        history.push(`/accounts/${response.data.id}`);
      } catch (err) {
        this.setState({ isDialogLoading: false });
        this.handleErrors(err);
      }
    } else {
      this.validateSave(
        this.state.newAccountName,
        this.state.newAccountCustomerId
      );
    }
  };

  handleErrors = error => {
    let errorData = error.response.data;
    let statusCode = errorData.statusCode;
    let name = errorData.name;

    if (name === "Validation Error") {
      let newState = this.state.invalidFields;
      if (statusCode === 400) {
        let body = errorData.body;
        body.forEach(fieldError => {
          let field = fieldError.field;
          let message = fieldError.message;

          if (field === "name") {
            newState.name.invalid = true;
            newState.name.message = message;
          }

          if (field === "customerId") {
            newState.customerId.invalid = true;
            newState.customerId.message = message;
          }
        });
      }
      this.setState({ invalidFields: newState });
      toastr.options = ToastOptions;
      toastr.error(`${errorData.message}.`);
    } else {
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  };

  queryAccounts = value => {
    let keyword = value.replace(/\s/g, "").toLowerCase();
    this.setState({ search_query: keyword, page: 0 }, () => {
      this.fetchAccounts();
    });
  };

  fetchAccounts = async () => {
    if (this.mount) {
      this.setState({ loading: true });
    }

    const params = {
      q: this.state.search_query.trim(),
      isActive: this.state.search_status,
      itemsPerPage: this.state.per_page,
      page: this.state.page,
      internal: this.state.search_internal
    };

    const query = `?per_page=${params.itemsPerPage}&page=${
        params.page
    }&status=${params.isActive}&keyword=${params.q}&internal=${params.internal}`;
    history.replace(`${query}`);
    this.setState({ queryParams: query });

    try {
      const accountsResponse = await AccountService.getAccountsByCriteria(
        params
      );
      const totalPages = accountsResponse.total_pages;
      if (this.mount) {
        this.setState({
          accounts: accountsResponse.accounts,
          loading: false,
          total_pages: totalPages
        });
      }
    } catch (error) {
      if (this.mount) {
        this.setState({ loading: false });
      }
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  };

  changePage = value => {
    if (value >= 0 && value < this.state.total_pages) {
      this.setState({page: value}, () => {
        this.fetchAccounts();
      });
    }
  };

  handleInternalFlagFilter = flag => {
    this.setState({search_internal: flag, page: 0}, () => {
      this.fetchAccounts();
    });
  }

  handleStatusFilter = status => {
    this.setState({search_status: status, page: 0}, () => {
      this.fetchAccounts();
    });
  };


  handleKeyPressSearch = e => {
    if (e.key === "Enter") {
      this.setState({ page: 0 }, () => {
        this.fetchAccounts();
      });
    }
  };

  handleSortColumn = () => {};

  handleQueryChange = e => {
    if (e.target.value === "") {
      this.setState({ search_query: "", page: 0 }, () => this.fetchAccounts());
    }
    this.setState({ search_query: e.target.value });
  };

  handlePageChange = e => {
    this.debouncePagination(e.selected);
  };

  onBlur = () => {
    this.setState({ isInFocus: false });
  };

  onFocus = () => {
    this.setState({ isInFocus: true });
  };

  render() {
    return (
      <App {...this.props}>
        <div className="accounts">
          <h2>
            Accounts
            {
              AuthorizationService.hasPermission(Permissions.account.add) &&
              <span className="create">
                <AddButton
                    name="Add Account"
                    handleCreateDialogToggle={this.handleAddAccountDialogToggle}
                />
              </span>
            }
          </h2>

          <div className="search-header">
            <div className="search-bar">
              <InputGroup>
                <Input
                  type="search"
                  name="search"
                  id="exampleSearch"
                  placeholder="Search"
                  value={this.state.search_query}
                  onChange={this.handleQueryChange}
                  onKeyPress={event => {
                    this.handleKeyPressSearch(event);
                  }}
                  autoComplete="off"
                  onFocus={this.onFocus}
                  onBlur={this.onBlur}
                />
                <InputGroupAddon addonType="append">
                  <FilterDropDown
                      options={[
                        {
                          value: "all",
                          label: "All"
                        },
                        {
                          value: "internal",
                          label: "Internal"
                        },
                        {
                          value: "external",
                          label: "External"
                        },
                      ]}
                      selectedStatus={this.state.search_internal}
                      handleAccountsFilter={this.handleInternalFlagFilter}
                  />
                </InputGroupAddon>
                <InputGroupAddon addonType="append">
                  <FilterDropDown
                      options={[{
                        value: "all",
                        label: "All"
                      }, {
                        value: "true",
                        label: "Active"
                      }, {
                        value: "false",
                        label: "Inactive"
                      },
                      ]}
                      selectedStatus={!this.state.search_status ? "all" : this.state.search_status}
                      handleAccountsFilter={this.handleStatusFilter}
                  />
                </InputGroupAddon>

                <InputGroupAddon addonType="append">
                  <Button
                      color="success"
                      onClick={() => {
                        this.setState({page: 0}, () => {
                          this.fetchAccounts();
                        });
                      }}
                  >
                    <FontAwesomeIcon icon="search"/>
                    &nbsp;Search
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </div>
          </div>

          <div className="search-body">
            {this.state.loading ? (
              <Loading className="account-loading" />
            ) : (
              <div>
                <AccountTable
                  accounts={this.state.accounts}
                  loading={this.state.loading}
                  handleSortColumn={this.handleSortColumn}
                  sortingField={this.state.sorting_field}
                  sortingOrder={this.state.sorting_order}
                  isInFocus={this.state.isInFocus}
                />
                <AccountsPagination
                  page={this.state.page}
                  total_pages={this.state.total_pages}
                  start={this.state.start}
                  end={this.state.end}
                  total_accounts={this.state.total_accounts}
                  handlePageChange={this.handlePageChange}
                />

                {/* Add account */}
                <CreateDialog
                  isModalVisible={this.state.isAddAccountModalVisible}
                  isDialogLoading={this.state.isDialogLoading}
                  handleDialogToggle={this.handleAddAccountDialogToggle}
                  action={this.addAccount}
                  modalHeaderName="New Account"
                  modalBodyFields={[
                    {
                      label: "Name",
                      id: "name",
                      inputType: "text",
                      onChange: this.validateName,
                      validateFieldName: "",
                      isFieldInvalid: this.state.invalidFields.name.invalid,
                      invalidFieldMessage: this.state.invalidFields.name.message,
                      newField: this.state.newAccountName,
                      defaultValue: this.state.newAccountName
                    },
                    {
                      label: "Customer ID",
                      id: "customerId",
                      inputType: "text",
                      onChange: this.validateCustomerId,
                      validateFieldName: "",
                      isFieldInvalid: this.state.invalidFields.customerId.invalid,
                      invalidFieldMessage: this.state.invalidFields.customerId.message,
                      newField: this.state.newAccountCustomerId,
                      defaultValue: this.state.newAccountCustomerId,
                      maxLength: "64",
                      fieldClassName: "name-container"
                    },
                    {
                      label: "Internal",
                      id: "internalFlag",
                      inputType: "checkbox",
                      onChange: this.setInternalFlag,
                      checked: this.state.newInternalFlag
                    }
                  ]}
                />
              </div>
            )}
          </div>
        </div>
      </App>
    );
  }
}



// WEBPACK FOOTER //
// ./src/accounts/Accounts.js